import type { Tool, ToolCategory } from '../../types/tools'
import { SCREENING_TOOLS } from './screening'
import { RESEARCH_TOOLS } from './research'
import { ANALYSIS_TOOLS } from './analysis'
import { PIPELINE_TOOLS } from './pipeline'

/** All ten tools, in directory order. */
export const TOOLS: Tool[] = [...SCREENING_TOOLS, ...RESEARCH_TOOLS, ...ANALYSIS_TOOLS, ...PIPELINE_TOOLS]

export const TOOL_FILTERS: { id: 'all' | ToolCategory; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'find', label: 'Find Deals' },
  { id: 'evaluate', label: 'Evaluate Deals' },
  { id: 'monitor', label: 'Monitor Portfolio' },
]

export const TOOLS_DIRECTORY = {
  title: 'AI Tools for Venture Capital Teams | DiligenceGPT™',
  description:
    'Explore DiligenceGPT™ tools for venture capital teams: pitch deck screening, investment memos, market and competitor research, data room review, financial analysis, deal sourcing and portfolio reporting.',
  h1: 'AI Tools for Venture Capital Teams',
  intro:
    'Start with the task in front of you — screening a deck, researching a market, drafting a memo — and carry the work forward. Each tool uses your fund’s criteria, and the output from one becomes the input for the next, from first look to portfolio reporting.',
}
